import { Component, Input, OnInit } from '@angular/core';
import { InjuryInfo } from '../../../../../models/api/view/claim/details/casualty/injury-info';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-injury-wc',
  imports: [DetailPanelComponent, DetailItemComponent, CardComponent],
  template: `
    <div class="tw-py-8">
      <app-card label="Injury">
        <div class="tw-flex tw-w-full tw-gap-8">
          <app-detail-panel [dataSource]="injuryData" class="tw-basis-1/3">
            <app-detail-item label="injury type" name="combinedInjuryType" />
            <app-detail-item
              label="accident occurred at"
              name="accidentOccurredAt"
            />
          </app-detail-panel>

          <app-detail-panel [dataSource]="injuryData" class="tw-basis-1/3">
            <app-detail-item
              label="wages paid for date of injury"
              name="wagesPaidForDateOfInjury"
              format="b"
            />
            <app-detail-item
              label="loss coverage"
              name="combinedLossCoverage"
            />
          </app-detail-panel>

          <app-detail-panel [dataSource]="injuryData" class="tw-basis-1/3">
            <app-detail-item
              label="Authorized to release medical"
              name="authorizedToReleaseMedical"
              format="b"
            />
            <app-detail-item
              label="Authorized to release SSN"
              name="authorizedToReleaseSSN"
              labelCase="none"
              format="b"
            />
          </app-detail-panel>
        </div>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class InjuryWcComponent extends BaseComponent implements OnInit {
  @Input() injury?: InjuryInfo;

  claimRow: ClaimRow;
  injuryData?: InjuryInfo & {
    combinedInjuryType: string;
    combinedLossCoverage: string;
  };

  ngOnInit(): void {
    this.claimRow = this.view.currentClaim();

    if (this.injury) {
      this.injuryData = {
        ...this.injury,
        combinedInjuryType: this.formatCodeWithDescription(
          this.injury.injuryType,
          this.injury.injuryTypeDescription,
        ),
        combinedLossCoverage: this.formatCodeWithDescription(
          this.injury.lossCoverage,
          this.injury.lossCoverageDescription,
        ),
      };
    }
  }

  private formatCodeWithDescription(
    code?: string,
    description?: string,
  ): string {
    if (code && description) {
      return `${code} ${description}`;
    }
    return description || code || '';
  }
}
